import { useQuery } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import {
	type GoalStateEnum,
	getGoalV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useGoalsQuery = (filterStates?: GoalStateEnum[]) => {
	return useQuery({
		queryKey: GoalsKeys.list(filterStates),
		queryFn: processResponse(() => getGoalV2(filterStates)),
	});
};
